export enum OrderStatus {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  IN_TRANSIT = 'IN_TRANSIT',
  OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY',
  DELIVERED = 'DELIVERED',
  CANCELLED = 'CANCELLED',
  RETURN_REQUESTED = 'RETURN_REQUESTED',
  REFUNDED = 'REFUNDED',
}

export enum PaymentMode {
  COD = 'cod',
  PREPAID = 'prepaid',
}

export enum ConfirmPaymentStatus {
  SUCCESS = 'success',
  FAILED = 'failed',
  PENDING = 'pending',
}

export interface OrderProduct {
  id: number;
  name: string;
  imageUrl: string;
  price: string;
  discountPrice: string | null;
  brandName: string;
  isSlaydOriginals: boolean;
}

export interface PriceBreakdown {
  productPrice: number;
  shippingFee: number;
  discount: number;
  finalPrice: number;
}

export interface OrderItem {
  id: number;
  product: OrderProduct;
  quantity: number;
  size: string | null;
  mrpAtPurchase: string;
  dealPriceAtPurchase: string;
}

export interface ShippingAddress {
  id?: string;
  name: string;
  line1: string;
  line2?: string;
  city: string;
  state: string;
  zipcode: string;
  contact: string;
}

export interface Order {
  id: number;
  orderId: number | null;
  product: OrderProduct;
  status: OrderStatus;
  quantity: number;
  size: string | null;
  orderedAt: string;
  mrpAtPurchase: string;
  dealPriceAtPurchase: string;
  items?: OrderItem[];
  razorpayOrderId: string | null;
  razorpayPaymentId: string | null;
  razorpayAmount?: string | null;
  paymentMode: PaymentMode | null;
  shippingAddress: ShippingAddress | null;
  priceBreakdown: PriceBreakdown;
}

export interface CreateOrderParams {
  productId: number;
  quantity: number;
  size?: string;
}

export interface ConfirmPaymentParams {
  paymentStatus: ConfirmPaymentStatus;
  razorpayPaymentId?: string;
  razorpaySignature?: string;
}

export interface GuestOrderItem {
  productId: number;
  productName: string;
  size: string | null;
  quantity: number;
  mrpAtPurchase: string;
  dealPriceAtPurchase: string | null;
  imageUrl?: string;
  brandName?: string;
}

export interface GuestOrder {
  guestOrderId: number;
  status: 'PENDING' | 'CONFIRMED' | 'FAILED';
  razorpayOrderId: string | null;
  razorpayStatus: string | null;
  razorpayAmount: string | null;
  razorpayAmountPaid: string | null;
  shippingAddress: ShippingAddress | null;
  shippingFee: string | null;
  codFee: string | null;
  paymentMode: PaymentMode | null;
  promotionDiscount: string | null;
  items: GuestOrderItem[];
  orderId: number | null;
}

export interface CreateGuestOrderParams {
  productId?: number;
  size?: string | null;
  quantity?: number;
  items?: {
    productId: number;
    quantity: number;
    size?: string | null;
  }[];
}

export interface ConfirmGuestPaymentParams {
  paymentStatus: ConfirmPaymentStatus;
  razorpayPaymentId?: string;
  razorpaySignature?: string;
  paymentMethod?: string;
}
